<template>
    <div class="fixed top-0 left-0 right-0 h-[60px] header_style flex z-10 items-center justify-between p-4">
        <div v-if="isSmallScreen">
            <div class="lg:hidden  flex  flex-row items-center w-screen -pl-2  justify-between ">
                <div class="flex col-span-1 justify-start">
                    <button id="mobile-menu-button" class="lg:hidden text-white focus:outline-none">
                        <i class="fa fa-bars text-xl"></i>
                    </button>
                </div>
                <div class="col-span-1 flex flex-row justify-center items-center">
                    <img alt="logo" class="w-auto h-8 mr-2" src="@/assets/logo.png" />
                    
                </div>

                <div class="col-span-1 flex justify-end">
                    <LoginModule @loginSucc="handleLogin" ref="loginModule" />
                </div>
            </div>
            <!--移动端导航菜单 -->
            <div id="mobile-menu" class="fixed inset-0 bg-gray-900/95 z-50 transform -translate-x-full transition-transform duration-300 ease-in-out lg:hidden">
                <div class="flex flex-row justify-between items-center p-5">
                    <div class="text-white font-bold text-xl">
                        <!-- 这里可以添加你的品牌标识或Logo -->
                        <span class="text-primary">识心</span>AI
                    </div>
                    <button id="close-menu-button" class="text-white focus:outline-none hover:text-primary transition-colors duration-200">
                        <i class="fa fa-times text-2xl"></i>
                    </button>
                </div>

                <!-- 主要菜单区域 -->
                <div class="flex flex-col items-center justify-center h-[calc(100vh-100px)] px-4">
                    <!-- 菜单项 -->
                    <div class="w-full max-w-xs">
                        <a @click="goToAnchor('navigater-header')" class="block text-white text-xl mb-6 py-3 px-5 rounded-lg hover:bg-primary/20 transition-all duration-300">
                            <i class="fa fa-home mr-3 text-primary"></i>首页
                        </a>

                        <a href="goToAnchor('anchor-pro')" class="block text-white text-xl mb-6 py-3 px-5 rounded-lg hover:bg-primary/20 transition-all duration-300">
                            <i class="fa fa-cubes mr-3 text-primary"></i>产品应用场景
                        </a>

                        <!-- 产品体系下拉菜单 -->
                        <div class="mb-6 w-full">
                            <button class="text-white text-xl flex flex-row items-center justify-between w-full py-3 px-5 rounded-lg bg-gradient-to-r from-primary/90 to-primary/70 shadow-lg hover:shadow-xl transition-all duration-300"
                                    @click="toggleProductMenu">
                                <div class="flex flex-row items-center">
                                    <i class="fa fa-sitemap mr-3"></i>
                                    <span class="font-medium">产品体系</span>
                                </div>
                                <i :class="['fa', productMenuOpen ? 'fa-chevron-up' : 'fa-chevron-down', 'text-sm transition-transform duration-300']"
                                   :style="{ transform: productMenuOpen ? 'rotate(180deg)' : 'rotate(0)' }"></i>
                            </button>

                            <div class="mt-2 w-full overflow-hidden transition-all duration-300 ease-in-out transform-gpu"
                                 :style="{
                maxHeight: productMenuOpen ? '500px' : '0',
                opacity: productMenuOpen ? '1' : '0',
                transform: productMenuOpen ? 'rotateX(0)' : 'rotateX(-90deg)',
                transformOrigin: 'top'                    }">
                                <div class="bg-white rounded-lg shadow-lg overflow-hidden">
                                    <ul>
                                        <!--<li>
                                            <a href="#" @click.prevent="gotoTeacherAI"
                                               class="block py-3 px-5 border-b border-gray-100 hover:bg-gray-50 transition-colors duration-200">
                                                <div class="flex flex-row items-center">
                                                    <div class="p-3 rounded-lg bg-blue-100 flex items-center justify-center mr-3">
                                                        <i class="fa fa-graduation-cap text-blue-600"></i>
                                                    </div>
                                                    <div class="flex flex-col">
                                                        <div class="font-medium text-gray-800">杏坛识心坊</div>
                                                        <div class="text-xs text-gray-500">校园智慧心理系统</div>
                                                    </div>
                                                </div>
                                            </a>
                                        </li>-->
                                        <li>
                                            <a href="#" @click.prevent="gotoCounselorAI"
                                               class="block py-3 px-5 hover:bg-gray-50 transition-colors duration-200">
                                                <div class="flex flex-row items-center">
                                                    <div class="p-4 rounded-lg bg-green-100 flex items-center justify-center mr-3">
                                                        <i class="fa fa-user-md text-green-600"></i>
                                                    </div>
                                                    <div class="flex flex-col">
                                                        <div class="font-medium text-gray-800">咨询师专业进化伙伴</div>
                                                        <div class="text-xs text-gray-500">心理咨询AI协同系统</div>
                                                    </div>
                                                </div>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#" @click.prevent="gotoYinliao"
                                               class="block py-3 px-5 hover:bg-gray-50 transition-colors duration-200">
                                                <div class="flex flex-row items-center">
                                                    <div class="p-4 rounded-lg bg-green-100 flex items-center justify-center mr-3">
                                                        <i class="fa fa-user-md text-green-600"></i>
                                                    </div>
                                                    <div class="flex flex-col">
                                                        <div class="font-medium text-gray-800">声愈·无境</div>
                                                        <div class="text-xs text-gray-500">全景声沉浸式疗愈</div>
                                                    </div>
                                                </div>
                                            </a>
                                        </li>
                                        
                                        <li>
                                            <a href="#" @click.prevent="gotoXinli"
                                               class="block py-3 px-5 border-b border-gray-100 hover:bg-gray-50 transition-colors duration-200">
                                                <div class="flex flex-row items-center">
                                                    <div class="p-4 rounded-lg bg-green-100 flex items-center justify-center mr-3">
                                                        <i class="fa fa-user-md text-green-600"></i>
                                                    </div>
                                                    <div class="flex flex-col">
                                                        <div class="font-medium text-gray-800">杏坛识心坊</div>
                                                        <div class="text-xs text-gray-500">智慧心理教育系统</div>
                                                    </div>
                                                </div>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#" @click.prevent="gotoLocalCounselorAI"
                                               class="block py-3 px-5 hover:bg-gray-50 transition-colors duration-200">
                                                <div class="flex flex-row items-center">
                                                    <div class="p-4 rounded-lg bg-blue-100 flex items-center justify-center mr-3">
                                                        <i class="fa fa-desktop text-blue-600"></i>
                                                    </div>
                                                    <div class="flex flex-col">
                                                        <div class="font-medium text-gray-800">咨询师专业进化助手</div>
                                                        <div class="text-xs text-gray-500">本地心理咨询AI协同系统</div>
                                                    </div>
                                                </div>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <a href="#" @click.prevent="gotoNewsInfo" class="block text-white text-xl mb-6 py-3 px-5 rounded-lg hover:bg-primary/20 transition-all duration-300">
                            <i class="fa fa-newspaper mr-3 text-primary"></i>识心动态
                        </a>
                        <a @click="goToAnchor('footerui')" class="block text-white text-xl mb-6 py-3 px-5 rounded-lg hover:bg-primary/20 transition-all duration-300">
                            <i class="fa fa-info-circle mr-3 text-primary"></i>关于我们
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="flex flex-row w-screen  justify-between ">
            <div class=" flex items-center justify-start">
                <img alt="logo" class=" w-32 h-10 bg-center bg-cover mr-2" src="@/assets/logo.png" />
                <!--<span class="text-xl text-white font-bold">识心智能</span>-->
            </div>
            
            <div class=" flex font-bold ml-10 h-full text-white  justify-center ">
                <div class="px-4 hover:text-primary">
                    <a href="#navigater-header">首页</a>
                </div>
                <div class="px-4 hover:text-primary">
                    <a href="#anchor-pro">产品应用场景</a>
                </div>

                <div class="relative px-4 hover:text-primary"
                     @mouseover="showMenu = true"
                     @mouseleave="showMenu = false"
                     @click="toggleMenu">
                    <a href="#" class="flex items-center">
                        产品体系
                        <i class="fa fa-chevron-down ml-1 text-xs" :class="{ 'rotate-180': showMenu }"></i>
                    </a>
                    <div v-show="showMenu"
                         @mouseenter="showMenu = true"
                         @mouseleave="showMenu = false"
                         class="absolute left-0 bg-white border border-gray-300 rounded shadow-lg left-1/2 transform -translate-x-1/2 z-50">
                        <ul class="p-0 m-0 text-black w-80">
                            <!--<li class="h-12 hover:text-primary border-b border-gray-300 flex items-center justify-center relative">
                                <a href="#" @click.prevent="gotoTeacherAI" class="block text-center">杏坛识心坊 |校园智慧心理系统</a>
                            </li>-->
                            <li class="h-12 hover:text-primary flex border-b border-gray-300  items-center justify-center relative">
                                <a href="#" @click.prevent="gotoCounselorAI" class="block text-center">咨询师专业进化伙伴 |心理咨询AI协同系统</a>
                                <div class="px-1 absolute bottom-0 right-0 text-xs bg-gray-300 font-medium">Beta</div>
                            </li>
                            <li class="h-12 hover:text-primary flex border-b border-gray-300  items-center justify-center relative">
                                <a href="#" @click.prevent="gotoXinli" class="block text-center">杏坛识心坊 |校园智慧心理系统</a>
                            </li>
                            <li class="h-12 hover:text-primary flex border-b border-gray-300 items-center justify-center relative">
                                <a href="#" @click.prevent="gotoYinliao" class="block text-center">声愈·无境|全景声沉浸式疗愈</a>
                            </li>
                            <li class="h-12 hover:text-primary flex items-center justify-center relative">
                                <a href="#" @click.prevent="gotoLocalCounselorAI" class="block text-center">咨询师专业进化助手 |本地心理咨询AI协同系统</a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="px-4 hover:text-primary">
                    <a href="#" @click.prevent="gotoNewsInfo"> 识心动态</a>
                </div>
                <div class="px-4 hover:text-primary">
                    <a href="#footerui">关于我们</a>
                </div>
            </div>
            <div class="flex justify-end ">
                <LoginModule @loginSucc="handleLogin" ref="loginModule" />
            </div>
        </div>

    </div>
</template>

<script>
    import LoginModule from '../LoginModule.vue';
    /*import axios from 'axios';*/
export default {

    components: {
        LoginModule,
        },
        metaInfo: {
          
        },
    data() {
        return {
            showMenu: false, // 控制导航选项的显示状态
            productMenuOpen: true,
            isLoggedInState: false,
            isUserMenuVisible: false,
            user: {},
        }
        },
        mounted() {
            document.addEventListener('DOMContentLoaded', function () {
                const mobileMenuButton = document.getElementById('mobile-menu-button');
                const closeMenuButton = document.getElementById('close-menu-button');
                const mobileMenu = document.getElementById('mobile-menu');

                if (mobileMenuButton && closeMenuButton && mobileMenu) {
                    mobileMenuButton.addEventListener('click', function () {
                        mobileMenu.classList.remove('-translate-x-full');
                    });

                    closeMenuButton.addEventListener('click', function () {
                        mobileMenu.classList.add('-translate-x-full');
                    });

                    // 点击菜单项关闭菜单
                    const menuItems = mobileMenu.querySelectorAll('a');
                    menuItems.forEach(item => {
                        item.addEventListener('click', function () {
                            mobileMenu.classList.add('translate-x-full');
                        });
                    });
                }
            });
        },
        methods: {
            goToAnchor(anchor) {
                this.$router.push({
                    path: '/',
                    hash: `#${anchor}`
                })
            },
            gotoNewsInfo() {
                if (this.$route.name !== 'NewsInfo') {
                    this.$router.push({ name: 'NewsInfo' });
                }
            },
            gotoTeacherAI() {
                this.$router.push({ name: 'TeacherAI' });
            },
            gotoXinli() {
                localStorage.setItem('curframe', "xinli");
                this.$router.push({ name: 'IframeModule' });
            },
            gotoYinliao() {
                localStorage.setItem('curframe', "yinliao");
                this.$router.push({ name: 'IframeModule' });
            },
            gotoCounselorAI() {
                this.$router.push({ name: 'CounselorAI' });
            },
            gotoLocalCounselorAI() {
                this.$router.push({ name: 'LocalCounselorAI' });
            },
            toggleMenu() {
                // 如果点击的是移动端，切换菜单显示状态
                if (window.innerWidth < 1024) {
                    this.showMenu = !this.showMenu;
                }
            },
            handleLogin(){},
            toggleProductMenu() {
                this.productMenuOpen = !this.productMenuOpen;
            },
    },
    created() {
        
    },
    computed: {
    },

}
</script>

<style>
    @import url('https: //cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css');
    .header_style {
        background: linear-gradient(135deg, #0a2136, #1a3b66) !important;
        border-bottom: 1px solid rgba(66, 153, 225, 0.4) !important;
        box-shadow: 0 5px 25px rgba(0, 0, 0, 0.5) !important;
    }
</style>

